"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RATINGS = exports.COMMENT_MAX_LENGTH = exports.INITIAL_RATING_VALUE = void 0;
exports.INITIAL_RATING_VALUE = 0;
exports.COMMENT_MAX_LENGTH = 280;
exports.RATINGS = [1, 2, 3, 4, 5];
